import {createReducer, on} from "@ngrx/store";
import * as UniverseAccountResourceActions from './universe-account-resource.actions';
import {UniverseAccountResource} from "../../models/UniverseAccountResource";
export const UniverseAccountResourceFeatureKey = 'universeAccountResource';
export const universeAccountResourceInitialState: UniverseAccountResource[] = null;
export const UniverseAccountResourceReducer = createReducer<UniverseAccountResource[] | null>(
  universeAccountResourceInitialState,
  on(UniverseAccountResourceActions.update, (_state, { universeAccountResources }) => universeAccountResources),
);
